import { Form, message } from "antd";
import React, { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import Dragger from "antd/es/upload/Dragger";
import svg94 from "../../../../assets/svg/svg94.svg";
import { formatPathJpa } from "../../../../utils";
import { saveFile } from "../../../../features/auth/authSlice";
import DocumentEditableTable from "./documents-applicants/DocumentEditableTable";

function DocumentsApplicant({
  handleNext,
  handleBack,
  form,
  fileUrlCv,
  setfileUrlCv,
  fileUrlCover,
  setfileUrlCover,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handlePrev = async () => {
    await handleBack();
  };

  async function handleSubmitStep() {
    try {
      await form.validateFields(["japCvFile", "japCoverLetterFile"]);
      await handleNext();
    } catch {}
  }

  const [fileName, setfileName] = useState("");
  const [fileLoading, setFileLoading] = useState(false);
  const propsCv = {
    name: "file",
    multiple: false,
    accept: "*",
    showUploadList: true,

    beforeUpload: async (file) => {
      // const isGt10MB = file.size / 1024 / 1024 > 10;

      // if (isGt10MB) {
      //   toast.error("File must be smaller than 10MB!");
      //   return;
      // }
      setFileLoading(true);

      const formData = new FormData();
      formData.append("file", file);

      try {
        const res = await dispatch(saveFile(formData)).unwrap();
        if (res?.success) {
          toast.success(`${file.name} file attached successfully.`);
          setfileUrlCv(res?.data?.result);
          setfileName(file.name);
        } else {
          message.error(`Upload failed: ${res.message}`);
          setfileUrlCv("");
          setfileName("");
        }
      } catch (err) {
        message.error(`Upload failed`);
        console.error(err);
      } finally {
        setFileLoading(false);
      }

      return false;
    },

    onDrop(e) {
      setFileLoading(false);
      console.log("Dropped files", e.dataTransfer.files);
    },
  };

  const propsCover = {
    name: "file",
    multiple: false,
    accept: "*",
    showUploadList: true,

    beforeUpload: async (file) => {
      // const isGt10MB = file.size / 1024 / 1024 > 10;

      // if (isGt10MB) {
      //   toast.error("File must be smaller than 10MB!");
      //   return;
      // }
      setFileLoading(true);

      const formData = new FormData();
      formData.append("file", file);

      try {
        const res = await dispatch(saveFile(formData)).unwrap();
        if (res?.success) {
          toast.success(`${file.name} file attached successfully.`);
          setfileUrlCover(res?.data?.result);
          setfileName(file.name);
        } else {
          message.error(`Upload failed: ${res.message}`);
          setfileUrlCover("");
          setfileName("");
        }
      } catch (err) {
        message.error(`Upload failed`);
        console.error(err);
      } finally {
        setFileLoading(false);
      }

      return false;
    },

    onDrop(e) {
      setFileLoading(false);
      console.log("Dropped files", e.dataTransfer.files);
    },
  };
  return (
    <>
      <div className="text-lightBlack text-[1.125rem] font-dmSans font-500">
        Upload Documents
      </div>
      <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-x-10 mt-[1.5rem]">
        <Form.Item
          name="japCvFile"
          label="Cv"
          rules={[
            {
              required: false,
              message: "Please upload cv file",
            },
          ]}
        >
          <Dragger
            className="attachment"
            {...propsCv}
            fileList={[]}
            showUploadList={false}
          >
            <div className="flex flex-col justify-center">
              <div className="flex justify-center mb-5">
                <img src={svg94} alt="svg94" />
              </div>
              <p className="ant-upload-text !ml-2">
                Choose a file
                <span className="ml-2 text-[#667085]">or drag and drop</span>
                <br></br>
                <span className="!mt-[10rem] text-[#667085]">
                  PNG or JPG (max. 800x400px) PDF
                </span>
              </p>
            </div>
          </Dragger>
          {formatPathJpa(fileUrlCv)}
        </Form.Item>
        <Form.Item
          name="japCoverLetterFile"
          label="Cover Letter"
          rules={[
            {
              required: false,
              message: "Please upload cover letter file",
            },
          ]}
        >
          <Dragger
            className="attachment"
            {...propsCover}
            fileList={[]}
            showUploadList={false}
          >
            <div className="flex flex-col justify-center">
              <div className="flex justify-center mb-5">
                <img src={svg94} alt="svg94" />
              </div>
              <p className="ant-upload-text !ml-2">
                Choose a file
                <span className="ml-2 text-[#667085]">or drag and drop</span>
                <br></br>
                <span className="!mt-[10rem] text-[#667085]">
                  PNG or JPG (max. 800x400px) PDF
                </span>
              </p>
            </div>
          </Dragger>
          {formatPathJpa(fileUrlCover)}
        </Form.Item>
      </div>
      <DocumentEditableTable
        handlePrev={handlePrev}
        handleSubmitStep={handleSubmitStep}
      />
      {/* <DocumentTable
        handlePrev={handlePrev}
        handleSubmitStep={handleSubmitStep}
      /> */}
    </>
  );
}

export default DocumentsApplicant;
